import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {DatePickerModule, TimePickerModule} from "@syncfusion/ej2-angular-calendars";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";

@Component({
    selector: 'app-form-time',
    imports: [
        TimePickerModule,
        DatePickerModule,
        ReactiveFormsModule
    ],
    templateUrl: './form-time.component.html',
    styleUrl: './form-time.component.scss'
})
export class FormTimeComponent implements OnChanges {

  @Input() public fCN: string = '';
  @Input() public disabled: boolean = false;
  @Input() public cssClass: string = '';
  @Input() public placeholder: string = '';
  @Input() public fG: FormGroup = new FormGroup({});
  @Input() public step: number = 15;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled'] && this.fG.controls[this.fCN]) {
      if (this.disabled) {
        this.fG.controls[this.fCN].disable();
      } else {
        this.fG.controls[this.fCN].enable();
      }
    }
  }
}
